export default __webpack_public_path__ + "static/Appliance-Removal-2a30d861ab0bb8b3b563293dddc081ce.jpg";